import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['MortgagePayoutEstimateController_calculate'];

export type MortgagePayoutEstimateBody = controller['requestBody']['content']['application/json'];
export type MortgagePayoutEstimateResponse = controller['responses']['200']['content']['application/json'];

export const mortgagePayoutEstimate = POST('/formulas/mortgage-payout-estimate')<
  MortgagePayoutEstimateBody,
  MortgagePayoutEstimateResponse
>;
